module.exports = __webpack_public_path__ + "img/hero.911b8932.png";